import Modal from './Modal';

export interface TemplatePlanet {
    title: string,
    icon: string,
    data: string
}

interface TemplatePlanetModalProps {
    templates: TemplatePlanet[],
    onClose?: any,
    onSelect?: any
}

function TemplatePlanetModal(props: TemplatePlanetModalProps) {
    const { onClose, onSelect, templates } = props;

    const onTemplateSelected = (template: TemplatePlanet) => {
        onSelect(template.data);
        onClose();
    }

    return (
        <Modal onClose={onClose}>
            <div className="small">
                <div className="title">Templates</div>
                {templates.map(template =>
                    <div key={template.title} className="image-button" onClick={() => onTemplateSelected(template)}>
                        <svg>
                            <use href={`#${template.icon}`} />
                        </svg>
                        <div>{template.title}</div>
                    </div>
                )}
                <div className="button" onClick={onClose}>Cancel</div>
            </div>
        </Modal>
    );
}

export default TemplatePlanetModal;
